@if (data) {
  <div class="web-view-container" [style.height]="getHeight(data.height_px)" [style.aspectRatio]="aspect_ratio" [attr.data-outboud-url]="data.outbound_url">
    @if (loading) {
      <app-loading-indicator type="circle"></app-loading-indicator>
    }
    @if (!loading && isYoutube) {
      <youtube-player class="youtube-comp" [videoId]="youtubeID" [playerVars]="{ autoplay: 1 }" (ready)="youtubeReady($event)"></youtube-player>
    }
    @if (safeURL && !loading && !isYoutube) {
      <iframe [src]="safeURL" frameborder="0" [style.height]="'100%'" class="content" scrolling="no" autoplay muted allowfullscreen>
      </iframe>
    }
    @if (!data.user_interaction_enabled) {
      <div class="overlay" (click)="openOutboundUrl()"></div>
    }
  </div>
}
